import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import Dolgozo from './Dolgozo.js';
import Szolgaltatas from './Szolgaltatas.js';
import User from './User.js';
import Sablon from './Sablon.js';
import Beallitasok from './Beallitasok.js';

class IdopontfoglaloBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  hasRole = (roleName) => {
    return this.props.globals.hasRole(roleName);
  }

  hasRoleSpec = (roleName) => {
    return this.props.globals.hasRoleSpec(roleName);
  }

  componentDidMount() {
    this.checkRole();
  }

  checkRole = () => {
    if (!this.hasRole(['IDOPONT_SZOLGALTATAS'])) {
      if (this.hasRole(['IDOPONT_DOLGOZO'])) {
        this.setState({ activeTab: '2' });
      } else if (this.hasRoleSpec(['IDOPONT_KAPCSOLO'])) {
        this.setState({ activeTab: '3' });
      } else {
        this.setState({ activeTab: '4' });
      }
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Időpontfoglaló
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {(this.hasRole(['IDOPONT_SZOLGALTATAS'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Szolgáltatás
                      </NavLink>
                    </NavItem>
                    : <div />}
                  {(this.hasRole(['IDOPONT_DOLGOZO'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggle('2'); }}
                      >
                        Dolgozó
                      </NavLink>
                    </NavItem>
                    : <div />}
                  {(this.hasRoleSpec(['IDOPONT_KAPCSOLO'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '3' })}
                        onClick={() => { this.toggle('3'); }}
                      >
                        Jogosultságok
                      </NavLink>
                    </NavItem>
                    : <div />}
                  {(this.hasRoleSpec(['IDOPONT_SABLON'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '4' })}
                        onClick={() => { this.toggle('4'); }}
                      >
                        E-mail sablon
                      </NavLink>
                    </NavItem>
                    : <div />}
                  {(this.hasRoleSpec(['IDOPONT_BEALLITAS'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '5' })}
                        onClick={() => { this.toggle('5'); }}
                      >
                        Beállítások
                      </NavLink>
                    </NavItem>
                    : <div />}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {(this.hasRole(['IDOPONT_SZOLGALTATAS'])) ?
                    <TabPane tabId="1">
                      <Szolgaltatas {...this.props} globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                    : <div />}
                  {(this.hasRole(['IDOPONT_DOLGOZO'])) ?
                    <TabPane tabId="2">
                      <Dolgozo {...this.props} globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                    : <div />}
                  {(this.hasRoleSpec(['IDOPONT_KAPCSOLO'])) ?
                    <TabPane tabId="3">
                      <User {...this.props} globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                    : <div />}
                  {(this.hasRoleSpec(['IDOPONT_SABLON'])) ?
                    <TabPane tabId="4">
                      <Sablon globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                    : <div />}
                  {(this.hasRoleSpec(['IDOPONT_BEALLITAS'])) ?
                    <TabPane tabId="5">
                      <Beallitasok globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                    : <div />}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IdopontfoglaloBase;
